export default __webpack_public_path__ + "7fc42eb55f57aead207ec2ee79310356.pdf";